import "./SecuritySolutions.module.css";
import MainHeader from "@/reusable_sections/Header";
import OurPlumbingSpecialties from "./sections/OurPlumbingSpecialties";
import OurBakingProcess from "./sections/OurBakingProcess";
import FrequentlyAskedQuestions from "./sections/FrequentlyAskedQuestions";
import CallToAction from "./sections/CallToAction";
import Footer from "@/reusable_sections/Footer";
export default function SecuritySolutionsPage() {
  return <div>
      <MainHeader />
      <OurPlumbingSpecialties />
      <OurBakingProcess />
      <FrequentlyAskedQuestions />
      <CallToAction />
      <Footer />
    </div>;
}